import { useSEO, SITE_URL } from '@/hooks/useSEO';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Stats from './components/Stats';
import Partners from './components/Partners';
import Services from './components/Services';
import Projects from './components/Projects';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  useSEO({
    title: 'Canel Elektrik | İstanbul Endüstriyel Elektrik ve İnşaat Taahhüt Mühendislik',
    description:
      "Canel Elektrik İnşaat Taahhüt Mühendislik – 1996'dan bu yana İstanbul'dan Türkiye genelinde ilaç, savunma sanayi ve endüstriyel tesisler için anahtar teslim elektrik ve inşaat projeleri. 1.250.000+ m² tamamlanmış alan.",
    keywords:
      'Canel Elektrik, endüstriyel elektrik taahhüt, anahtar teslim inşaat İstanbul, orta gerilim sistemi, endüstriyel tesis mühendislik',
    canonical: '/',
    schema: [
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'Canel Elektrik İnşaat Taahhüt Mühendislik',
        alternateName: 'Canel Elektrik',
        url: SITE_URL,
        logo: `${SITE_URL}/favicon.png`,
        foundingDate: '1996',
        description:
          "1996'dan bu yana İstanbul merkezli anahtar teslim elektrik ve inşaat taahhüt mühendislik firması.",
        address: {
          '@type': 'PostalAddress',
          streetAddress: 'Perpa Ticaret Merkezi, A Blok Kat: 5 No: 204',
          addressLocality: 'Okmeydanı, Şişli',
          addressRegion: 'İstanbul',
          addressCountry: 'TR',
        },
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '+90-212-220-52-56',
          contactType: 'customer service',
          email: 'info@can-el.com',
          areaServed: 'TR',
          availableLanguage: ['Turkish', 'English'],
        },
        sameAs: ['https://www.can-el.com'],
      },
      {
        '@context': 'https://schema.org',
        '@type': 'LocalBusiness',
        name: 'Canel Elektrik İnşaat Taahhüt Mühendislik',
        image: `${SITE_URL}/og-image.jpg`,
        url: SITE_URL,
        telephone: '+90-212-220-52-56',
        email: 'info@can-el.com',
        address: {
          '@type': 'PostalAddress',
          streetAddress: 'Perpa Ticaret Merkezi, A Blok Kat: 5 No: 204',
          addressLocality: 'Okmeydanı, Şişli',
          addressRegion: 'İstanbul',
          postalCode: '34384',
          addressCountry: 'TR',
        },
        geo: {
          '@type': 'GeoCoordinates',
          latitude: 41.0603,
          longitude: 28.9693,
        },
        openingHoursSpecification: [
          {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
            opens: '09:00',
            closes: '18:00',
          },
          {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: 'Saturday',
            opens: '09:00',
            closes: '12:00',
          },
        ],
        priceRange: '$$',
        servesCuisine: undefined,
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: 'Canel Elektrik Mühendislik',
        url: SITE_URL,
        inLanguage: ['tr', 'en'],
        description:
          "Türkiye'nin önde gelen endüstriyel EPC firması. Elektrik mühendisliği ve anahtar teslim inşaat hizmetleri.",
      },
    ],
  });

  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <Stats />
      <Services />
      <Projects />
      <About />
      <Partners />
      <Contact />
      <Footer />
    </div>
  );
}